export const interpolateMarkdown = (
  content: string,
  variables: Record<string, string>
): string => {
  return content.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, key) => {
    return variables[key] ?? '';
  });
};
